import * as Sentry from '@sentry/react'

const sentryDSN: string = import.meta.env.VITE_REACT_APP_SENTRY_DSN
const sentryEnvironment: string = import.meta.env.VITE_REACT_APP_SENTRY_ENVIRONMENT
const sentryTracesSampleRate: number = import.meta.env.VITE_REACT_APP_SENTRY_TRACES_SAMPLE_RATE

function isEmptyOrNull(str: string | null | undefined): boolean {
  return str === null || str === undefined || str.trim() === ''
}

const shouldUseSentry = (): boolean => {
  try {
    return !isEmptyOrNull(sentryDSN) && sentryDSN !== 'null' // could be string value null in SSM
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error while checking if Sentry should be used', e)
    return false
  }
}

const setupSentry = (): void => {
  if (shouldUseSentry()) {
    Sentry.init({
      dsn: sentryDSN,
      integrations: [Sentry.browserTracingIntegration()],
      environment: sentryEnvironment,
      maxValueLength: 8000,

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: sentryTracesSampleRate,
      // TODO: Add tracingOrigins when we have a list of origins
      tracePropagationTargets: ['localhost', /^https:\/\/odyssey-poc\.humanforce\.io/],
    })
  }
}

const getSentry = (): typeof Sentry | null => {
  if (shouldUseSentry()) {
    return Sentry
  }

  return null
}

const setSentryUser = (username: string) => {
  if (shouldUseSentry()) {
    Sentry.setUser({ username })
    Sentry.addBreadcrumb({
      category: 'auth',
      message: `User logged in: ${username}`,
      level: 'info',
    })
  }
}

const clearSentryUser = () => {
  if (shouldUseSentry()) {
    Sentry.setUser(null)
  }
}

export { setupSentry, getSentry, setSentryUser, clearSentryUser }
